import { render, staticRenderFns } from "./review-sent.vue?vue&type=template&id=2b6ffbfe"
import script from "./review-sent.vue?vue&type=script&lang=js"
export * from "./review-sent.vue?vue&type=script&lang=js"
import style0 from "./review-sent.vue?vue&type=style&index=0&id=2b6ffbfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports